
import {Vue, Component} from "vue-property-decorator";
import api from "@/api/index";
import $ from 'jquery'
import {
  OrganizationUnitDto,
  ProfitReportStandardDto,
  ProfitType,
  StoreYearlySaleReportDto,
  StoreYearlySaleReportMonthlyItemDto
} from "@/api/appService";

const ouKey = "Abp-OrganizationUnitId";
import Cookies from "js-cookie";
import XLSX, {WritingOptions} from 'xlsx'
import {WriteFileOptions} from "fs";
import ExportTableHtml from "@/components/ExportTableHtml/index.vue";
import ReportTable from "@/views/report/component/report-table.vue";
import ReportTip from "@/views/report/component/report-tip.vue";

export const getOu = () => Cookies.get(ouKey);

interface OrgSale {
  orgId: number;
  orgName: string;
  children?: OrgSale[],
  data?: StoreYearlySaleReportMonthlyItemDto[]
}

class DataTree {

  orgId!: number;
  orgName!: string;
  children?: DataTree[];
  level: string;
  data?: StoreYearlySaleReportMonthlyItemDto[]

  private _yearlyTotal?: number;


  constructor(orgId: number, orgName: string, level: string) {
    this.orgId = orgId;
    this.orgName = orgName;
    this.level = level
  }

  private _rowSpan?: number;
  private _tempCount: number = 0;


  get rowSpan() {

    if (this.children === undefined || this.children.length === 0) {
      return 0
    }

    if (this._rowSpan) {
      return this._rowSpan!;
    }

    this._calcRowCount(this.children)


    if (this.level === '片区') {
      this._tempCount++
    } else if (this.level === '大区') {
      this._tempCount += this.children.length
    }


    this._rowSpan = this._tempCount;

    return this._rowSpan

  }

  private _calcRowCount(data?: DataTree[]) {
    if (data) {
      data.forEach((item) => {
        if (item.children && item.children.length) {
          this._calcRowCount(item.children)
        } else {
          if (item.level === '门店') {
            this._tempCount++
          }

        }
      })
    }
  }

  get yearlyTotal() {

    if (this._yearlyTotal === undefined) {
      if (this.data && this.data.length) {
        let value = 0
        for (let i = 0; i < this.data.length; i++) {
          value += this.data[i].amount!
        }
        this._yearlyTotal = value
      } else {
        this._yearlyTotal = 0
      }
    }
    return this._yearlyTotal;

  }

  get subYearlyTotal() {
    if (!this.children || !this.children.length) {
      return 0
    }
    let result = 0

    for (let i = 0; i < this.children.length; i++) {
      result += this.children[i].yearlyTotal
    }

    return result
  }

  clearCache(){
    this._yearlyTotal = undefined;
  }

}

interface StoreIncomeName {
  isFirst: boolean,
  rowspan: number,
  itemName: string
}

class StoreIncomeRow {

  private _names: { [key: number]: StoreIncomeName } = {}
  private _maxLevel: number = 0
  mappedTreeItem!: DataTree

  month1: number;
  month2: number;
  month3: number;
  month4: number;
  month5: number;
  month6: number;
  month7: number;
  month8: number;
  month9: number;
  month10: number;
  month11: number;
  month12: number;

  isSubTotalMode: boolean = false;


  private _id: string = Math.random().toString();

  constructor() {

    this.month1 = 0
    this.month2 = 0
    this.month3 = 0
    this.month4 = 0
    this.month5 = 0
    this.month6 = 0
    this.month7 = 0
    this.month8 = 0
    this.month9 = 0
    this.month10 = 0
    this.month11 = 0
    this.month12 = 0

  }

  setAsSubTotalRow(treeNode: DataTree) {
    this.isSubTotalMode = true;
    this.calcSubTotal(treeNode.children)
  }

  calcSubTotal(treeItems?: DataTree[]) {
    if (!treeItems || treeItems.length === 0) {
      return
    }

    treeItems.forEach(treeNode => {
      this.calcSubTotal(treeNode.children)

      if (treeNode.data && treeNode.data.length === 12) {
        this.month1 += treeNode.data![0]!.amount!
        this.month2 += treeNode.data![1]!.amount!
        this.month3 += treeNode.data![2]!.amount!
        this.month4 += treeNode.data![3]!.amount!
        this.month5 += treeNode.data![4]!.amount!
        this.month6 += treeNode.data![5]!.amount!
        this.month7 += treeNode.data![6]!.amount!
        this.month8 += treeNode.data![7]!.amount!
        this.month9 += treeNode.data![8]!.amount!
        this.month10 += treeNode.data![9]!.amount!
        this.month11 += treeNode.data![10]!.amount!
        this.month12 += treeNode.data![11]!.amount!
      }

    })

  }


  setLevelItem(level: number, name: StoreIncomeName) {
    this._names[level] = name;
    if (level > this._maxLevel) {
      this._maxLevel = level;
    }
  }


  isLevelSetAsFirst(level: number) {
    if (this._names[level]) {
      return this._names[level].isFirst
    } else {
      return false;
    }
  }

  get id() {
    return this._id
  }

  hasLevel(level: number) {
    if (this._names[level]) {
      return true;
    } else {
      return false;
    }
  }

  getItemName(level: number) {
    if (this._names[level]) {
      return this._names[level].itemName
    } else {
      return ''
    }
  }

  getLevel(level: number) {
    return this._names[level]
  }

  getAllNames() {
    return this._names;
  }

  get storeName() {
    return this._names[this._maxLevel].itemName
  }

}


@Component({
  components: {ReportTip, ReportTable, ExportTableHtml}
})
export default class StoreIncomeReport extends Vue {


  queryForm: any = {
    year: undefined,
    organizationUnitId: undefined
  };
  loading: boolean = true;

  dataTree: DataTree[] = []
  orgSaleDetailMap: { [key: number]: OrgSale } = {}

  rowDataList: StoreIncomeRow[] = []


  get profitType() {
    return ProfitType.Store;
  }

  get ouLevel() {
    return (this.$store.getters['user/ou'] as OrganizationUnitDto).level
  }

  async created() {

    this.queryForm.year = new Date().getFullYear();

    await this.buildDataTreeStruct()

    await this.fetchDetail();
  }

  mounted() {
    // 监听窗口大小变化，重新计算冻结列位置
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.applyFrozenColumns();
  }


  async fetchDetail() {
    this.loading = true;
    await api.profitReport
        .getStoreYearlySaleReport({
          year: this.queryForm.year
        })
        .then(res => {
          this.loading = false;
          res.items?.forEach(item => {
            item.monthlyValues = item.monthlyValues!.sort((a,b)=>(a.month??0)-(b.month??0))

            if(this.orgSaleDetailMap[item.storeId!]){
              this.orgSaleDetailMap[item.storeId!].data = item.monthlyValues
            }

          })

          const result = this.buildRows(this.dataTree, 0, undefined);
          this.rowDataList = result
          console.log('rows', result);

          setTimeout(()=>{
            console.log('resize table')
            $('#shopSaleReportTable thead tr th.strong').css({width:'112px'})
            this.applyFrozenColumns()
          },1000)

        });
  }

  async buildDataTreeStruct() {

    const ou = this.$store.getters['user/ou'] as OrganizationUnitDto

    await api.organizationUnit.getOrganizationUnitsOfDescendantBySession({withMe: false}).then(res => {
      let tree: DataTree[];
      if (ou.level === '总部') {
        tree = this.createDataTree(res, undefined)
      } else {
        tree = this.createDataTree(res, ou.id)
      }
      tree = this.clearDataTree(tree)
      this.dataTree = tree
      console.log('dataTree', this.dataTree)

    })
  }

  getAllTotal(){
    let result = 0
    for(const item in this.orgSaleDetailMap){
      const data = this.orgSaleDetailMap[item].data

      if(data && data.length){

        data.forEach(dataItem=>{
          result += dataItem.amount!
        })
      }
    }
    return result;
  }

  getMonthTotal(month:number){
    let result = 0
    for(const item in this.orgSaleDetailMap){
      const data = this.orgSaleDetailMap[item].data
      if(data && data.length){
        result += data[month -1].amount!
      }
    }
    return result
  }

  createDataTree(allData: OrganizationUnitDto[], parentId?: number) {
    const children = allData.filter(s => s.parentId === parentId || ((parentId === null || parentId === undefined) && (s.parentId === undefined || s.parentId === null)));
    if (!children || !children.length) {
      return []
    }

    return children.map(child => {
      const treeItem = new DataTree(child.id!, child.displayName!, child.level!)
      treeItem.children = this.createDataTree(allData, child.id)
      treeItem.data = []
      if (!treeItem.children || !treeItem.children.length) {
        this.orgSaleDetailMap[child.id!] = treeItem
      }

      return treeItem

    })
  }

  clearDataTree(tree: DataTree[]) {
    const newTree: DataTree[] = []
    if (!tree || tree.length === 0) {
      return newTree
    }

    tree.forEach((treeNode) => {

      let newTreeNode: DataTree
      newTreeNode = <DataTree><any> null;

      if (treeNode.children && treeNode.children.length) {
        const subTree = this.clearDataTree(treeNode.children)
        if (subTree.length > 0) {
          newTreeNode = treeNode
          newTreeNode.children = subTree
        }
      } else {
        if (treeNode.level === '门店') {
          newTreeNode = treeNode
        }
      }

      if (newTreeNode) {
        newTree.push(newTreeNode)
      }
    })

    return newTree

  }


  buildRows(treeItems: DataTree[], level: number, row?: StoreIncomeRow) {
    if (!treeItems || treeItems.length === 0) {
      return []
    }

    let rows: StoreIncomeRow[] = []
    treeItems.forEach((treeItem, index) => {
      treeItem.clearCache();

      if (!row) {
        row = new StoreIncomeRow();
      }


      if (treeItem.children && treeItem.children.length) {
        // 如果row有数据，说明是从上级传入的数据 ，则表示它是第一行
        row.setLevelItem(level, {isFirst: true, itemName: treeItem.orgName, rowspan: treeItem.rowSpan})
        const subRows = this.buildRows(treeItem.children, level + 1, row)
        rows = [...rows, ...subRows]

        if (treeItem.level === '片区' && subRows.length > 0) {
          let subTotalRow = new StoreIncomeRow()
          subTotalRow.setLevelItem(level + 1, {rowspan: 1, itemName: '合计', isFirst: false})
          subTotalRow.setAsSubTotalRow(treeItem)
          subTotalRow.mappedTreeItem = treeItem

          rows.push(subTotalRow)
        }

      } else {

        if (!row.hasLevel(level)) {
          row.setLevelItem(level, {isFirst: false, itemName: treeItem.orgName, rowspan: 1})
        }

        if (treeItem.data && treeItem.data.length) {
          row.month1 = treeItem.data![0]!.amount!
          row.month2 = treeItem.data![1]!.amount!
          row.month3 = treeItem.data![2]!.amount!
          row.month4 = treeItem.data![3]!.amount!
          row.month5 = treeItem.data![4]!.amount!
          row.month6 = treeItem.data![5]!.amount!
          row.month7 = treeItem.data![6]!.amount!
          row.month8 = treeItem.data![7]!.amount!
          row.month9 = treeItem.data![8]!.amount!
          row.month10 = treeItem.data![9]!.amount!
          row.month11 = treeItem.data![10]!.amount!
          row.month12 = treeItem.data![11]!.amount!
          row.mappedTreeItem = treeItem
        }
      }

      if (treeItem.level === '门店') {
        rows.push(row);
      }

      row = undefined

    })


    return rows;

  }


  // 应用冻结列效果
  applyFrozenColumns() {
    const table = $('#shopSaleReportTable');
    if (!table.length) return;

    // 获取所有表头的冻结列，并计算每列的宽度和偏移量
    const headerCells = table.find('thead tr th');
    const columnWidths: number[] = [];
    const columnOffsets: number[] = [];
    const frozenColumnIndices: number[] = [];

    let leftOffset = 0;
    let colIndex = 0;

    headerCells.each((index, cell) => {
      const $cell = $(cell);
      const width = $cell.outerWidth() || 0;
      const isFrozen = $cell.hasClass('frozen-col');

      columnWidths.push(width);
      columnOffsets.push(leftOffset);

      if (isFrozen) {
        frozenColumnIndices.push(colIndex);
        $cell.css({
          left: `${leftOffset}px`
        });
        leftOffset += width;
      }

      colIndex++;
    });

    // 为每一行的 tbody 设置冻结列位置
    // 使用一个二维数组来跟踪每个单元格占据的位置
    const rows = table.find('tbody tr');
    const rowCount = rows.length;
    const colCount = headerCells.length;

    // 创建一个矩阵来跟踪哪些位置已被占据（用于处理 rowspan）
    const cellMatrix: (JQuery | null)[][] = [];
    for (let i = 0; i < rowCount; i++) {
      cellMatrix[i] = new Array(colCount).fill(null);
    }

    // 遍历每一行，填充矩阵
    rows.each((rowIndex, row) => {
      const $row = $(row);
      const cells = $row.find('td');
      let matrixColIndex = 0;

      cells.each((cellIndex, cell) => {
        const $cell = $(cell);

        // 找到下一个未被占据的列位置
        while (matrixColIndex < colCount && cellMatrix[rowIndex][matrixColIndex] !== null) {
          matrixColIndex++;
        }

        if (matrixColIndex >= colCount) return;

        const colspan = parseInt($cell.attr('colspan') || '1');
        const rowspan = parseInt($cell.attr('rowspan') || '1');

        // 在矩阵中标记这个单元格占据的所有位置
        for (let r = 0; r < rowspan; r++) {
          for (let c = 0; c < colspan; c++) {
            if (rowIndex + r < rowCount && matrixColIndex + c < colCount) {
              cellMatrix[rowIndex + r][matrixColIndex + c] = $cell;
            }
          }
        }

        // 如果是冻结列，设置其 left 位置
        if ($cell.hasClass('frozen-col')) {
          if ($cell.hasClass('frozen-col-merged')) {
            // 合并列始终从 0 开始
            $cell.css({
              left: '0px'
            });
          } else {
            // 根据列索引设置正确的 left 值
            const offset = columnOffsets[matrixColIndex] || 0;
            $cell.css({
              left: `${offset}px`
            });
          }
        }

        matrixColIndex += colspan;
      });
    });
  }

  // 搜索
  async handleSearch() {
    await this.fetchDetail();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      year: new Date().getFullYear(),
      organizationUnitId: Number(getOu())
    };
    await this.fetchDetail();
  }


}
